import { queryOptions, useQuery } from '@tanstack/react-query';

import { ApiResponse, QueryOptions } from '@cast/shared-types';

import { apiClient } from '@cast/infrastructure-api';

import { overrideOrganizationHeader } from '@cast/api-client';

export const ENTERPRISE_GROUPS_QUERY_KEY = 'enterprise-groups';

type EnterpriseGroupsQueryData = ApiResponse<
  typeof apiClient.enterprises.listUserGroups
>;

type EnterpriseGroupsBaseQueryArgs<TSelect = EnterpriseGroupsQueryData> = {
  enterpriseId: string;
} & QueryOptions<EnterpriseGroupsQueryData, TSelect, Error>;

type EnterpriseGroupsQueryArgs<TSelect = EnterpriseGroupsQueryData> = Pick<
  EnterpriseGroupsBaseQueryArgs<TSelect>,
  'enterpriseId' | 'enabled'
>;

const getEnterpriseGroupsQueryKey = (params: { enterpriseId: string }) =>
  [ENTERPRISE_GROUPS_QUERY_KEY, params.enterpriseId] as const;

const getEnterpriseGroupsQueryOptions = <TSelect = EnterpriseGroupsQueryData>({
  enterpriseId,
  enabled,
}: EnterpriseGroupsQueryArgs<TSelect>) =>
  queryOptions({
    queryKey: getEnterpriseGroupsQueryKey({ enterpriseId }),
    queryFn: async () => {
      const { data } = await apiClient.enterprises.listUserGroups(
        {
          enterpriseId,
          pageLimit: '9999',
        },
        {
          headers: overrideOrganizationHeader(enterpriseId),
        }
      );
      return data.items ?? [];
    },
    enabled,
  });

export const useEnterpriseGroupsQuery = <TSelect = EnterpriseGroupsQueryData>({
  enterpriseId,
  enabled,
}: EnterpriseGroupsQueryArgs<TSelect>) =>
  useQuery(getEnterpriseGroupsQueryOptions({ enterpriseId, enabled }));
